import {all, call, put, takeEvery} from 'redux-saga/effects'
import {
  VideoFilesActionTypes, deleteError, deleteSuccess, fetchError, fetchSuccess, createError, createSuccess,
  updateSuccess, updateError, fetchItemSuccess, fetchItemError
} from '@actions/video-file'
import videoApi from '@api/video-file'
import {ReduxAction} from "@actions/index";
import transcoding from '@api/transcoding'



function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(videoApi.getList, payload);
    yield put(fetchSuccess(res));
  } catch (err) {
    yield put(fetchError(err))
  }
}


function* handleDelete({payload}: ReduxAction) {
  try {
    yield call(videoApi.delete, payload);
    yield put(deleteSuccess(payload.params));
  } catch (err) {
    yield put(deleteError(err))
  }
}


function* handleCreate({payload}: ReduxAction) {
  try {
    const data = yield call(transcoding.saveFile, payload);
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    // yield put(createSuccess())
  }
  catch (err) {
    yield put(createError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(transcoding.saveFile, payload);
    payload.onSuccessCallback && payload.onSuccessCallback();
    yield put(updateSuccess(data))
  }
  catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


function* handleFetchItem({payload}: ReduxAction) {
  try {
    const {data} = yield call(videoApi.getItem, payload);
    yield put(fetchItemSuccess(data))
  } catch (err) {
    yield put(fetchItemError(err))
  }
}


// We can also use `fork()` here to split our saga into multiple watchers.
function* videoContentsSaga() {
  yield all([
    yield takeEvery(VideoFilesActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(VideoFilesActionTypes.DELETE_REQUEST, handleDelete),
    yield takeEvery(VideoFilesActionTypes.CREATE_REQUEST, handleCreate),
    yield takeEvery(VideoFilesActionTypes.UPDATE_REQUEST, handleUpdate),
    yield takeEvery(VideoFilesActionTypes.FETCH_ITEM_REQUEST, handleFetchItem),
  ])
}

export default videoContentsSaga
